import React, { useState, useEffect, memo } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './SwitchButton.scss';
import Tooltip from '../ToolTip';

function SwitchButton({
  items,
  containerStyle,
  itmesStyle,
  dynamicBackgroundStyle,
  onclick,
  active,
  activeClass,
  isRounded,
  allActive,
  tooltipContent,
  ...props
}) {
  const width = 100 / items.length;
  let currentIndex = items.findIndex((itm) => itm.name === active);
  const [position, setPostion] = useState(width * currentIndex);
  const [currentChoose, setCurrentChoose] = useState(currentIndex);

  useEffect(() => {
    setPostion(width * currentIndex);
    setCurrentChoose(currentIndex);
  }, [active]);

  const calPosition = (key) => {
    setPostion(key * width);
  };

  const content = (
    <div
      className={`SwitchButton text-nowrap d-flex align-items-center justify-content-around position-relative ${containerStyle} 
        ${allActive && 'DisabledSwitch'} 
        `}
    >
      {items.map((item, index) => {
        return (
          <div
            className={`d-flex align-items-center position-relative justify-content-center text-center items ${
              allActive ? 'cursor-not-allowed' : 'cursor-pointer'
            } ${itmesStyle}
              ${
                currentChoose == index || allActive ? 'text-white' : 'text-dark'
              }`}
            style={{
              zIndex: 2,
              width: `${width}%`,
            }}
            key={index}
            onClick={(event) => {
              if (allActive) return;
              setCurrentChoose(index);
              calPosition(index);
              onclick(item.name.split('.')[1]);
            }}
          >
            <span className={` ${allActive ? 'all-active-icon' : ''}`}>
              {item.iconTag}
            </span>
            <span className="px-1">
              {props.intl.formatMessage({ id: item.name })}
            </span>
          </div>
        );
      })}

      {!allActive && (
        <span
          className={`dynamicBackground ${
            !isRounded && 'p-1'
          }  position-absolute h-100 ${dynamicBackgroundStyle}`}
          style={{
            zIndex: 1,
            width: `${width}%`,
            left: `${props.language.direction == 'ltr' ? `${position}%` : ''}`,
            right: `${props.language.direction == 'rtl' ? `${position}%` : ''}`,
          }}
        >
          <div
            className={`${activeClass} w-100 h-100 ${
              isRounded
                ? currentChoose == 0
                  ? `default-border-${
                      props.language.direction == 'rtl' ? 'right' : 'left'
                    }-radius-xsmall`
                  : currentChoose == items.length - 1
                  ? `default-border-${
                      props.language.direction == 'rtl' ? 'left' : 'right'
                    }-radius-xsmall`
                  : 'default-border-radius-xsmall'
                : ''
            }`}
          />
        </span>
      )}

      {allActive && (
        <span
          className={` position-absolute h-100 `}
          style={{
            zIndex: 1,
            width: '100%',
          }}
        >
          <div
            className={`${activeClass} w-100 h-100 ${
              isRounded ? 'default-border-radius-xsmall' : ''
            }`}
          ></div>
        </span>
      )}
    </div>
  );
  return allActive ? (
    <Tooltip
      position="top"
      content={tooltipContent}
      backgroundColor="secondary"
      textColor="white"
      customClassName="w-100"
    >
      {content}
    </Tooltip>
  ) : (
    content
  );
}

SwitchButton.propTypes = {
  items: PropTypes.array,
  containerStyle: PropTypes.string,
  itmesStyle: PropTypes.string,
  dynamicBackgroundStyle: PropTypes.string,
  onclick: PropTypes.func,
  activeClass: PropTypes.string,
  isRounded: PropTypes.bool,
  allActive: PropTypes.bool,
  tooltipContent: PropTypes.string,
};

SwitchButton.defaultProps = {
  items: [
    { name: 'first', iconTag: <></> },
    { name: 'secound', iconTag: <></> },
    { name: 'third', iconTag: <></> },
  ],
  containerStyle:
    'bg-third-dark border bordre-primary default-border-radius-small py-2',
  itmesStyle: 'default-border-radius-small ',
  dynamicBackgroundStyle: '',
  activeClass: 'bg-secondary-light default-border-radius-small ',
  isRounded: false,
  allActive: false,
  tooltipContent: '',
};

function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}

export default injectIntl(connect(mapStateToProps)(memo(SwitchButton)));

/** 
  items: Array of string
  containerStyle: style for main container look like background color (for background color you most send background color to this )
  itmesStyle: style for all items for emxaple padding,margin and ... (never set background color)
  dynamicBackgroundStyle: style for dynamic background look like background color (never set padding);
  onclick: for return value when user click on eacth items
  *** for all style never set width or height ***

_if set col to the containerStyle set px-0

useage
  const item=["first", "secound", "third", "fourth"];
  <SwitchButton items={item} />

*/
